export function setTitle(title) {
  document.title = title ? `${title} ` : 'Lnt';
}
